// src/features/engine/components/ProjectCompletion.jsx

import { useProgramEngine } from "../../engine/context/ProgramEngineContext";

export default function ProjectCompletion() {

  const { goToResults, project } = useProgramEngine();

  return (
    <div style={{ padding: 24 }}>

      <h2>🎉 {project.title} completed</h2>

      <button onClick={goToResults}>
        View Results
      </button>

    </div>
  );
}